var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "clientContactForm",
      staticClass: "contact-inputs mb-0",
      attrs: {
        "label-position": "top",
        rules: _vm.rules,
        model: _vm.contactLocal
      }
    },
    [
      _c(
        "div",
        { staticClass: "flex-row" },
        [
          _c(
            "el-form-item",
            {
              staticClass: "wp-5",
              attrs: {
                prop: "forename",
                label: _vm.$t.__("common.labels.first_name")
              }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.contactLocal.forename,
                  callback: function($$v) {
                    _vm.$set(_vm.contactLocal, "forename", $$v)
                  },
                  expression: "contactLocal.forename"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "wp-5 ml-4",
              attrs: { prop: "name", label: _vm.$t.__("common.labels.name") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.contactLocal.name,
                  callback: function($$v) {
                    _vm.$set(_vm.contactLocal, "name", $$v)
                  },
                  expression: "contactLocal.name"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "email",
            label: _vm.$t.__("common.labels.email_address")
          }
        },
        [
          _c("el-input", {
            model: {
              value: _vm.contactLocal.email,
              callback: function($$v) {
                _vm.$set(_vm.contactLocal, "email", $$v)
              },
              expression: "contactLocal.email"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: { prop: "phone.e164", label: _vm.$t.__("common.labels.phone") }
        },
        [
          _c("tel-input", {
            staticClass: "wp-10 contact-input-tel",
            attrs: { mode: "edit" },
            on: { change: _vm.updatePhone },
            model: {
              value: _vm.contactLocal.phone,
              callback: function($$v) {
                _vm.$set(_vm.contactLocal, "phone", $$v)
              },
              expression: "contactLocal.phone"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-row flex-right" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary"
            },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            staticClass: "ml-3",
            attrs: { label: _vm.$t.__("common.actions.save"), type: "primary" },
            on: {
              click: function($event) {
                return _vm.submitForm("clientContactForm", "submit")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }